# Dashboard Estratégico de Obras - Componente de Tabela
# Gerencia filtros, paginação, ordenação e listagem de obras

import StantFlashMessages from "../../../utils/stant_flash_messages.coffee"

import * as I18n from "../../../services/i18n"
import translations from "../../../translations"

class ObrasDashboardTable
  constructor: ->
    @currentPage = 1
    @perPage = 10
    @currentFilters = {}
    @currentSort = { by: 'titulo', direction: 'asc' }
    @pagination = {}
    @chartComponent = null
    @initializeElements()

  initializeElements: ->
    @$loadingState = $('#loading-state')
    @$tableContainer = $('#obras-table-container')
    @$tableBody = $('#obras-table-body')
    @$emptyState = $('#empty-state')
    @$errorState = $('#error-state')
    @$filterForm = $('#obras-filter-form')
    @$entitySelect = $('#entity_ids')
    @$statusSelect = $('#strategic_status_ids')
    @$perPageSelect = $('#per-page-select')
    @$tableInfoText = $('#table-info-text')
    @$paginationContainer = $('#pagination-container')

  init: ->
    @bindEvents()
    @setupPerPageSelect()
    @loadFilterOptions()
    @loadObras()

  setupPerPageSelect: ->
    @$perPageSelect.val(@perPage)

  bindEvents: ->
    @$filterForm.on 'submit', (e) =>
      e.preventDefault()
      @applyFilters()

    $('#clear-filters').on 'click', =>
      @clearFilters()

    $('#retry-button').on 'click', =>
      @loadObras()

    $(document).on 'click', '.sortable', (e) =>
      e.preventDefault()
      @handleSort($(e.currentTarget))

    @$perPageSelect.on 'change', =>
      @handlePerPageChange()

    # Event handlers para modal de edição
    $(document).on 'click', '.edit-strategic-status-btn', (e) =>
      @openEditModal($(e.currentTarget))

    $('#save-strategic-status-btn').on 'click', =>
      @saveStrategicStatus()



  handlePerPageChange: ->
    @perPage = parseInt(@$perPageSelect.val())
    @currentPage = 1
    @loadObras()

  handleSort: ($header) ->
    sortBy = $header.data('sort')
    
    if @currentSort.by == sortBy
      @currentSort.direction = if @currentSort.direction == 'asc' then 'desc' else 'asc'
    else
      @currentSort.by = sortBy
      @currentSort.direction = 'asc'
    
    @updateSortIcons($header)
    @currentPage = 1
    @loadObras()

  updateSortIcons: ($activeHeader) ->
    $('.sortable').removeClass('sort-asc sort-desc')
    
    if @currentSort.direction == 'asc'
      $activeHeader.addClass('sort-asc')
    else
      $activeHeader.addClass('sort-desc')

  loadFilterOptions: ->
    $.ajax
      url: '/dashboard_estrategico/search_entities'
      method: 'GET'
      data: { all: true }
      success: (data) =>
        @populateEntitySelect(data)
      error: (xhr, status, error) ->
        console.error 'Erro ao carregar entidades:', error, xhr.responseText

    $.ajax
      url: '/dashboard_estrategico/strategic_statuses'
      method: 'GET'
      success: (data) =>
        @populateStatusSelect(data)
      error: (xhr, status, error) ->
        console.error 'Erro ao carregar Estados Agrupados:', error, xhr.responseText

  populateEntitySelect: (entities) ->
    try
      if @$entitySelect.hasClass('select2-hidden-accessible')
        @$entitySelect.select2('destroy')
      
      @$entitySelect.empty()
      # Don't add placeholder option - let Select2 handle it
      
      for entity in entities
        @$entitySelect.append("<option value='#{entity.id}'>#{entity.name}</option>")
      
      @$entitySelect.select2
        theme: 'bootstrap4'
        placeholder: 'Selecione...'
        allowClear: true
        width: '100%'
      
    catch error
      console.error 'Error initializing entity Select2:', error

  populateStatusSelect: (statuses) ->
    try
      if @$statusSelect.hasClass('select2-hidden-accessible')
        @$statusSelect.select2('destroy')
      
      @$statusSelect.empty()
      # Don't add placeholder option - let Select2 handle it
      
      for status in statuses
        @$statusSelect.append("<option value='#{status.id}'>#{status.name}</option>")
      
      @$statusSelect.select2
        theme: 'bootstrap4'
        placeholder: 'Selecione...'
        allowClear: true
        width: '100%'
      
    catch error
      console.error 'Erro ao carregar Estados Agrupados:', error

  loadObras: ->
    @showLoading()
    
    params = $.extend({}, @currentFilters, {
      page: @currentPage,
      per_page: @perPage,
      sort_by: @currentSort.by,
      sort_direction: @currentSort.direction
    })

    $.ajax
      url: '/dashboard_estrategico/obras'
      method: 'GET'
      data: params
      success: (response) =>
        @hideLoading()
        @pagination = response.pagination || {}
        @renderObras(response.data || [])
        @updateTableInfo()
        @renderPagination()
      error: (xhr, status, error) =>
        @hideLoading()
        @showError()
        console.error 'Erro ao carregar:', error, xhr.responseText

  renderObras: (obras) ->
    if obras && obras.length > 0
      @showTable()
      @renderTableRows(obras)
    else
      @showEmptyState()

  renderTableRows: (obras) ->
    rows = $.map obras, (obra) ->
      editButton = """
        <button type="button" class="btn link-view edit-strategic-status-btn" 
                data-obra-id="#{obra.id}" 
                data-obra-name="#{obra.name || ''}"
                data-sub-strategic-status-id="#{obra.sub_strategic_status_id || ''}"
                title="Editar Estado Estratégico">
          <i class="icon icon-edit"></i>
        </button>
      """
      
      """
      <tr>
        <td>#{obra.name || ''}</td>
        <td class="txt-center">#{obra.entity_name || ''}</td>
        <td class="txt-center">#{obra.strategic_status_name || ''}</td>
        <td class="txt-center">#{obra.sub_strategic_status_name || ''}</td>
        <td class="txt-center">#{obra.start_date || ''}</td>
        <td class="txt-center">#{editButton}</td>
      </tr>
      """

    @$tableBody.html(rows.join(''))

  updateTableInfo: ->
    if @pagination.total_count > 0
      startItem = (@pagination.current_page - 1) * @pagination.per_page + 1
      endItem = Math.min(startItem + @pagination.per_page - 1, @pagination.total_count)
      @$tableInfoText.text("Mostrando #{startItem} a #{endItem} de #{@pagination.total_count}")
    else
      @$tableInfoText.text("Nenhuma obra encontrada")

  renderPagination: ->
    if @pagination.total_pages <= 1
      @$paginationContainer.hide()
      return

    html = '<div class="pagination">'
    
    # Botão Previous
    if @pagination.has_prev
      html += '<a href="#" class="prev" data-page="' + (@pagination.current_page - 1) + '"></a>'
    else
      html += '<a href="#" class="prev disabled"></a>'

    # Números das páginas
    startPage = Math.max(1, @pagination.current_page - 2)
    endPage = Math.min(@pagination.total_pages, @pagination.current_page + 2)

    if startPage > 1
      html += '<a href="#" data-page="1">1</a>'
      if startPage > 2
        html += '<a href="#" class="disabled">...</a>'

    for page in [startPage..endPage]
      if page == @pagination.current_page
        html += '<a href="#" class="active">' + page + '</a>'
      else
        html += '<a href="#" data-page="' + page + '">' + page + '</a>'

    if endPage < @pagination.total_pages
      if endPage < @pagination.total_pages - 1
        html += '<a href="#" class="disabled">...</a>'
      html += '<a href="#" data-page="' + @pagination.total_pages + '">' + @pagination.total_pages + '</a>'

    # Botão Next
    if @pagination.has_next
      html += '<a href="#" class="next" data-page="' + (@pagination.current_page + 1) + '"></a>'
    else
      html += '<a href="#" class="next disabled"></a>'

    html += '</div>'
    
    @$paginationContainer.html(html).show()

    @$paginationContainer.off('click').on 'click', 'a', (e) =>
      e.preventDefault()
      $link = $(e.currentTarget)
      
      return if $link.hasClass('disabled') || $link.hasClass('active')
      
      page = parseInt($link.data('page'))
      if page && page != @pagination.current_page
        @currentPage = page
        @loadObras()

  # Definir referência ao componente de gráfico
  setChartComponent: (chartComponent) ->
    @chartComponent = chartComponent

  applyFilters: ->
    @currentFilters = {
      entity_ids: @$entitySelect.val() || []
      strategic_status_ids: @$statusSelect.val() || []
      start_date_from: $('#start_date_from').val()
      start_date_to: $('#start_date_to').val()
    }
    
    for key, value of @currentFilters
      if !value || (Array.isArray(value) && value.length == 0)
        delete @currentFilters[key]
    
    @currentPage = 1
    @loadObras()
    @updateChart()

  clearFilters: ->
    # Clear Select2 elements properly - use null to clear completely
    @$entitySelect.val(null).trigger('change')
    @$statusSelect.val(null).trigger('change')
    
    # Clear date fields
    $('#start_date_from').val('')
    $('#start_date_to').val('')
    
    # Clear datepickers as well (also handled by Stimulus controller)
    $('.pickadate').each ->
      picker = $(@).data('pickadate')
      if picker
        picker.clear()
    
    @currentFilters = {}
    @currentPage = 1
    @loadObras()
    @updateChart()

  # Atualizar gráfico com filtros atuais (sem paginação)
  updateChart: ->
    if @chartComponent
      @chartComponent.updateWithFilters(@currentFilters)

  # Estados da interface
  showLoading: ->
    @$loadingState.show()
    @$tableContainer.hide()
    @$emptyState.hide()
    @$errorState.hide()

  hideLoading: ->
    @$loadingState.hide()

  showTable: ->
    @$tableContainer.show()
    @$emptyState.hide()
    @$errorState.hide()

  showEmptyState: ->
    @$tableContainer.hide()
    @$emptyState.show()
    @$errorState.hide()

  showError: ->
    @$tableContainer.hide()
    @$emptyState.hide()
    @$errorState.show()

  # Métodos para gerenciar modal de edição
  openEditModal: ($button) ->
    obraId = $button.data('obra-id')
    obraName = $button.data('obra-name')
    subStrategicStatusId = $button.data('sub-strategic-status-id')

    # Preencher dados da obra
    $('#edit-obra-id').val(obraId)
    $('#edit-obra-name').text(obraName)

    # Carregar todos os sub estados estratégicos
    @loadSubStrategicStatusesForModal(subStrategicStatusId)

    # Abrir modal
    $('#editStrategicStatusModal').modal('show')

  loadSubStrategicStatusesForModal: (selectedSubStrategicStatusId = null) ->
    $.ajax
      url: '/dashboard_estrategico/sub_strategic_statuses'
      method: 'GET'
      success: (data) =>
        @populateSubStatusSelect(data, selectedSubStrategicStatusId)
      error: (xhr, status, error) =>
        console.error 'Erro ao carregar Estados:', error, xhr.responseText
        @showErrorMessage('Erro ao carregar Estados. Tente novamente.')

  populateSubStatusSelect: (subStatuses, selectedId = null) ->
    $select = $('#edit-sub-strategic-status-select')
    
    # Destruir Select2 se existir
    if $select.hasClass('select2-hidden-accessible')
      $select.select2('destroy')
    
    # Limpar e popular options
    $select.empty()
    $select.append('<option></option>')
    
    for subStatus in subStatuses
      selected = if subStatus.id == selectedId then 'selected' else ''
      console.log(subStatus.id, selectedId, selected)
      $select.append("<option value='#{subStatus.id}' #{selected}>#{subStatus.name}</option>")

#      console.log(this, I18n.t(translations(), 'construction_site_status_manager.index.modal.select_sub_strategic_status'))

    # Inicializar Select2
    $select.select2
      theme: 'bootstrap4'
      placeholder: I18n.t(translations(), 'construction_site_status_manager.index.modal.placeholder')
      allowClear: true
      width: '100%'
      dropdownParent: $('#editStrategicStatusModal')

  saveStrategicStatus: ->
    obraId = $('#edit-obra-id').val()
    subStrategicStatusId = $('#edit-sub-strategic-status-select').val() || null

    if !obraId
      return

    # Desabilitar botão e mostrar loading
    $saveBtn = $('#save-strategic-status-btn')
    originalText = $saveBtn.text()
    $saveBtn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Salvando...')

    $.ajax
      url: "/dashboard_estrategico/update_strategic_status/#{obraId}"
      method: 'PATCH'
      dataType: 'json'
      data:
        sub_strategic_status_id: subStrategicStatusId
      success: (response) =>
        $saveBtn.prop('disabled', false).html(originalText)
        $('#editStrategicStatusModal').modal('hide')
        
        # Recarregar tabela e gráfico
        @loadObras()
        @updateChart()
        
        # Mostrar mensagem de sucesso
        @showSuccessMessage(response.message || 'Estado estratégico atualizado com sucesso!')
      error: (xhr, status, error) =>
        $saveBtn.prop('disabled', false).html(originalText)
        
        try
          response = JSON.parse(xhr.responseText)
          message = response.message || 'Erro ao atualizar estado estratégico'
        catch
          message = 'Erro ao atualizar estado estratégico'
        
        @showErrorMessage(message)

  # Funções utilitárias para mensagens
  showSuccessMessage: (message) ->
    if typeof toastr isnt 'undefined'
      toastr.success(message)
    else
      @renderFlashMessage('notice', message)

  showErrorMessage: (message) ->
    if typeof toastr isnt 'undefined'
      toastr.error(message)
    else
      @renderFlashMessage('alert', message)

  renderFlashMessage: (type, message) ->
    cssClass = if type == 'notice' then 'alert-box success' else 'alert-box error'
    
    flashHtml = """
      <div class="container">
        <div class="grid_6 push_3 flash-messages">
          <div class="#{cssClass} animated bounceInRight">
            <p>
              #{message}
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            </p>
          </div>
        </div>
      </div>
    """
    
    new StantFlashMessages(flashHtml).render_floating()

window.ObrasDashboardTable = ObrasDashboardTable 